/* Version: 3.5.155 */
'use client';
import _merge from 'lodash/merge';
import React, { useMemo } from 'react';
import { JohnHancock, Manulife, ManulifeFr } from '@manulife/mux-logos';
import i18n from '../../lang/i18n/index.js';
import LANG from '../../lang/lang.js';
import LogoComponent from './LogoComponent.js';
import { jsx } from 'react/jsx-runtime';
import useLang from '../../hooks/useLang.js';
import useTheme from '../../hooks/useTheme.js';

var WordmarkLogo = function WordmarkLogo(_ref) {
  var _logo$props;
  var alt = _ref.alt,
    as = _ref.as,
    href = _ref.href,
    logo = _ref.logo,
    onClick = _ref.onClick;
  var lang = useLang();
  var theme = useTheme();
  var DefaultLogo = useMemo(function () {
    var _theme$name;
    if (theme !== null && theme !== undefined && (_theme$name = theme.name) !== null && _theme$name !== undefined && _theme$name.includes('johnhancock')) {
      return /*#__PURE__*/jsx(JohnHancock.BLACK, {});
    }
    return lang === LANG.EN_CA ? /*#__PURE__*/jsx(Manulife.WORDMARK_BLACK, {}) : /*#__PURE__*/jsx(ManulifeFr.WORDMARK_BLACK, {});
  }, [lang, theme === null || theme === undefined ? undefined : theme.name]);
  var logoStyle = _merge({}, {
    // Set defaults from theme
    height: theme.sideNav.wordmarkLogo.height,
    maxWidth: theme.sideNav.wordmarkLogo.maxWidth,
    pointerEvents: !href && !onClick ? 'none' : undefined
  }, logo === null || logo === undefined || (_logo$props = logo.props) === null || _logo$props === undefined ? undefined : _logo$props.style // Override with user-provided styles via the logo component
  );
  var Logo = /*#__PURE__*/React.cloneElement(logo || DefaultLogo, {
    'aria-hidden': !href && !onClick ? true : undefined,
    'data-testid': 'wordmark-logo',
    style: logoStyle,
    title: alt || i18n[lang].sideNav.wordmarkLogo
  }, null);
  return /*#__PURE__*/jsx(LogoComponent, {
    as: as,
    "aria-label": alt || i18n[lang].sideNav.wordmarkLogo,
    "aria-hidden": !href && !onClick ? true : undefined,
    "data-testid": "wordmark-logo-component",
    href: href,
    onClick: onClick,
    type: "wordmark",
    children: Logo
  });
};

export { WordmarkLogo as default };
